import { Attr, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type User from "./User";

@Model()
class OrganisationAggregationMultiplier extends ApplicationRecord {
  static jsonapiType = "organisation_aggregation_multipliers";

  @Attr() audienceMultiplier: number;

  @Attr({ persist: false }) audienceMultiplierLastUpdatedAt: string;

  @HasOne() audienceMultiplierLastUpdatedBy: User;

  @Attr() aveMultiplier: number;

  @Attr({ persist: false }) aveMultiplierLastUpdatedAt: string;

  @HasOne() aveMultiplierLastUpdatedBy: User;

  @HasOne() organisation: Organisation;

  @Attr() organisationId: number;
}

export default OrganisationAggregationMultiplier;
